import { render, staticRenderFns } from "./errorList.vue?vue&type=template&id=5287c659&"
import script from "./errorList.vue?vue&type=script&lang=js&"
export * from "./errorList.vue?vue&type=script&lang=js&"
import style0 from "./errorList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports